/** @jsxImportSource @emotion/react */

import { Redo2 as Redo2Icon } from 'lucide-react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import history from 'modules/overlay-canvas/addons/history';
import UDIconButton from 'ud-ui/components/icon-button';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from 'modules/template-editor/store/editor/selectors';

export function Redo() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const [isActive, setIsActive] = React.useState(history.isInit() ?? history.redoIsActive());

  const onClickRedo = () => {
    if (!fabricManager) return;
    history.redo();
  };

  useEffect(() => {
    history.history.subscribe(() => {
      setIsActive(history.redoIsActive());
    });
    history.index.subscribe(() => {
      setIsActive(history.redoIsActive());
    });
  }, []);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Вперед'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <UDIconButton
          variant="ghost"
          icon={<Redo2Icon size={20} strokeWidth={1.5} />}
          onClick={onClickRedo}
          disabled={!isActive}
          tabIndex={0}
        />
      </span>
    </UDTippy>
  );
}
